import React, { useCallback, useEffect, useState, useMemo, useRef } from 'react';
import { connect } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import loadable from '@loadable/component';
import Header, { PAGE_NAME } from '../../../common/component/AffiliateHeader';
import { captureEvent } from '../../../../analytics/analytics';
import { modifyPdtData, modifySectionForPDT } from './pdtUtils';
import { getAllUrlParams } from '../../helpers/utils';
import OmnitureUtils from '../../../common/utils/Omniture/OmnitureUtils';
import ListingBody from './ListingBody';
import ModifySearch from './ModifySearch';
import Footer from './Footer';
import {
  getListingFiltersAction,
  getListingMetaDataAction,
} from '../../redux/actions/listingMetadataActions';
import { getGroupMetaDataAction } from '../../redux/actions/listingGroupActions';
import {
  getInitialPackagesAction,
  pageLoadingAction,
} from '../../redux/actions/listingPackagesActions';
import {
  isMobile,
  isAgentLoggedIn,
  getUrlParamsMapV2,
  getIframeValue,
  reload,
} from '../../../common/utils/browserUtils';
import ListingBanner from './ListingBanner';
import {
  getListingSectionsAction,
  getUserPackagesAction,
} from '../../redux/actions/sectionsActions';
import {
  getSearchListAction,
  updateInitialValuesFromUrlAction,
} from '../../redux/actions/searchActions';
import { getMenuAction } from '../../redux/actions/subMenuAction';
import setGlobalVariable from '../../../common/utils/mmtGlobalVariable';
import { getCookie } from '../../../common/service/cookieService';
// import CoachmarkUtils from '../../../common/utils/Coachmark';
// import {
//   CLOSE_COACHMARK_CLICKED,
//   PAGE_NAME_LIST,
// } from '../../../common/constants/coachmarkConstant';
// import { coachmarkUtils } from '../../../common/utils/Coachmark/utils';
import { getMMT_HLD_OBJ } from '../../../common/utils/appUtils';
import {
  setBlockerCountAction,
  setNotificationsAction,
} from '../../redux/actions/notificationsActions';
import { getNotificationsList } from '../../redux/services';
import { PAGENAME_LIST } from '../../../common/constants/appConstant';
import Analytics from '../../../../analytics';
import 'pwa-mmt-ui-header/ssr/header.css';
import '../../../common/css/coachmarkV2.scss';
import './listing.scss';
import { saveCMPDetails } from '../../../common/src/utils/utils';
import { getLocationNodeForPdt } from '../../../../analytics/analytics-utils';
import { PDT_PAGETYPE } from '../../../common/constants/pdtConstant';
import { VALID_SECTION_CODES, CUSTOM_SECTIONS } from '../../constants/sectionConstants';

/**
 * Whenever you have an external library which is not ssr compatible
 * i.e it has window and document used inside it without ssr check please use
 * react loadable.
 */
const ContactManagementWrapper = loadable(
  () => import(/* webpackChunkName: 'ContactMAnagement' */ './ContactManagementWrapper'),
  {
    ssr: false,
  }
);

const InterventionWrapper = loadable(
  () => import(/* webpackChunkName: 'Intervention_Roadblock' */ './InterventionWrapper'),
  {
    ssr: false,
  }
);

const NotificationsOverlay = loadable(
  () =>
    import(
      /* webpackChunkName: 'Notifications_Overlay' */ '../../../common/component/NotificationsOverlay'
    ),
  {
    ssr: false,
  }
);

const NotificationsInfoModal = loadable(
  () =>
    import(
      /* webpackChunkName: 'Notifications_Info' */ '../../../common/component/NotificationsInfoModal'
    ),
  {
    ssr: false,
  }
);

const HolidayListing = ({
  getListingMetaDataAction,
  getGroupMetaDataAction,
  getInitialPackagesAction,
  initialDataLoaded,
  getListingSectionsAction,
  getUserPackagesAction,
  updateInitialValuesFromUrlAction,
  getSearchListAction,
  getMenuAction,
  listingFilters,
  groupMetadataIsLoading,
  packagesLoaded,
  branch,
  paxDetails,
  metadata,
  getListingFiltersAction,
  setNotificationsAction,
  notificationsData = {},
  setBlockerCountAction,
  pendingNotificationsCount,
  unReadNotificationsCount,
  pageLoadingAction,
  packages,
  nextOffset,
  sectionsByOrderObj,
  activeTab,
}) => {
  const [showAutosuggest, setAutoSuggest] = useState(false);
  const [loadEventSource, setLoadEventSource] = useState(null);
  const [showNotifications, setNotificationsPanel] = useState(false);
  const [showNotificationsModal, setNotificationsModal] = useState(false);
  const [search] = useSearchParams();

  // const [coachMarkShown, updateCoachmarkShown] = useState(
  //   !JSON.parse(window.localStorage.getItem(CLOSE_COACHMARK_CLICKED))
  // );

  const isFirstRender = useRef(true);

  const { dest, packageIds } = useMemo(() => {
    const urlParams = getAllUrlParams(search);
    const { dest, depCity, packageIds } = urlParams;
    return { dest, depCity, packageIds };
  }, [search]);

  const getInitialData = useCallback(async () => {
    await setGlobalVariable();
    await updateInitialValuesFromUrlAction();
    await getSearchListAction();
    await getMenuAction();
    await getListingFiltersAction();
    await getListingMetaDataAction();
    await getGroupMetaDataAction();
    await getInitialPackagesAction();
    await getListingSectionsAction();
    await getUserPackagesAction();
    await pageLoadingAction(false);
  }, [getListingMetaDataAction, getGroupMetaDataAction, getInitialPackagesAction]);

  const [isBannerShow, setIsBannerShow] = useState(true);
  const bannerHeightRef = useRef();

  // useEffect(() => {
  //   updateCoachmarkShown(!JSON.parse(window.localStorage.getItem(CLOSE_COACHMARK_CLICKED)));
  // }, [JSON.parse(window.localStorage.getItem(CLOSE_COACHMARK_CLICKED))]);

  useEffect(() => {
    if (metadata?.destinationMeta || paxDetails) {
      const destinationData = metadata.destinationMeta?.destinationCities?.[0];
      const departureData = metadata.destinationMeta?.departureCity;
      if (departureData) {
        Analytics.setGlobalData({
          departureDetails: getLocationNodeForPdt(departureData),
          destinationDetails: getLocationNodeForPdt(destinationData),
          lob_category: metadata?.branch,
          paxDetails: paxDetails?.reduce(
            (acc, val) => ({
              noOfAdults: acc?.noOfAdults || 0 + (val?.noOfAdults || 0),
              noOfInfants: acc?.noOfInfants || 0 + (val?.noOfInfants || 0),
              noOfChildrenWOB: acc?.noOfChildrenWOB || 0 + (val?.noOfChildrenWOB || 0),
              ageOfChildrenWOB: acc?.ageOfChildrenWOB.concat(val?.listOfAgeOfChildrenWOB),
            }),
            { noOfAdults: 0, noOfInfants: 0, noOfChildrenWOB: 0, ageOfChildrenWOB: [] }
          ),
          lob_category: metadata?.branch,
          departureDate: metadata?.departureDate,
          tags: metadata?.tags,
          pageContextPageType: getMMT_HLD_OBJ()?.fromSEO
            ? PDT_PAGETYPE.TEMPLATE
            : PDT_PAGETYPE.FUNNEL,
        });
      }
    }
  }, [metadata]);
  const { showPDO } = getMMT_HLD_OBJ();

  const sectionsByOrder = useMemo(() => {
    let filteredSectionByOrder = {};
    if (Object.keys(sectionsByOrderObj)?.length > 0) {
      filteredSectionByOrder = Object.values(sectionsByOrderObj)?.filter(data => {
        if (
          (data?.[0]?.sectionCode === VALID_SECTION_CODES.RECENTLY_VIEWED && !showPDO) ||
          (data?.[0]?.sectionCode === VALID_SECTION_CODES.PDO && showPDO) ||
          (data?.[0]?.sectionCode !== VALID_SECTION_CODES.PDO &&
            data?.[0]?.sectionCode !== VALID_SECTION_CODES.RECENTLY_VIEWED)
        ) {
          return data;
        }
      });
    }

    return filteredSectionByOrder;
  }, [JSON.stringify(sectionsByOrderObj)]);

  const setSectionsData = () => {
    const pdtCurrentSections = [];
    Object?.values(sectionsByOrder)?.map(sectionDataArr => {
      sectionDataArr?.map(sectionDataObj => {
        if (sectionDataObj.cards?.length > 0) {
          pdtCurrentSections.push(modifySectionForPDT(sectionDataObj));
        }
      });
    });
    if (activeTab?.sections) {
      for (const section of activeTab?.sections || []) {
        pdtCurrentSections.push(modifySectionForPDT(section));
      }
    }
    if (activeTab?.groupCards) {
      activeTab.groupCards.map(groupCard => {
        pdtCurrentSections.push(
          modifySectionForPDT({
            ...groupCard,
            sectionCode: CUSTOM_SECTIONS.CONTENT_CARD,
            type: CUSTOM_SECTIONS.CONTENT_CARD,
            order: groupCard?.position || 0,
          })
        );
      });
    }
    return pdtCurrentSections;
  };

  useEffect(() => {
    if (packages && Object.keys(sectionsByOrderObj).length !== 0) {
      const pdtData = modifyPdtData(packages);
      const components = {};
      components.product_list = pdtData;
      const sectionLoaded = setSectionsData();
      components.content_details = sectionLoaded;
      if (isFirstRender.current) {
        isFirstRender.current = false;
        captureEvent({
          event_type: Analytics.EVENT_TYPES.LIFE_CYCLE,
          event_name: Analytics.EVENT_NAMES.PAGE_RELOAD,
          event_value: 'page-rendered',
          components,
        });
      }
    }
  }, [packages, sectionsByOrderObj]);

  useEffect(() => {
    if (bannerHeightRef.current) {
      const bannerHt = bannerHeightRef.current.clientHeight;
      const handleScroll = () => {
        if (window.scrollY > bannerHt - 10) {
          setIsBannerShow(false);
        } else {
          setIsBannerShow(true);
        }
      };
      window.addEventListener('scroll', handleScroll);
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }
  }, [bannerHeightRef.current]);

  useEffect(() => {
    pageLoadingAction(true);
    if (!initialDataLoaded && !getMMT_HLD_OBJ().fromSEO) {
      getInitialData();
    }
  }, [getInitialData, initialDataLoaded]);

  const themes = getMMT_HLD_OBJ().theme;
  const newLoadEventSource = packageIds?.split(',').length ? 'packageIds' : dest || themes || '';

  if (
    (dest || themes || packageIds?.split(',').length) &&
    !groupMetadataIsLoading &&
    loadEventSource !== newLoadEventSource
  ) {
    setLoadEventSource(newLoadEventSource);
    OmnitureUtils.trackLoadEvent();
  }

  useEffect(() => {
    captureEvent({
      event_type: Analytics.EVENT_TYPES.LIFE_CYCLE,
      event_name: Analytics.EVENT_NAMES.PAGE_ENTRY,
      event_value: 'page-entry',
    });
  }, []);

  const getNotificationsData = async () => {
    try {
      const response = await getNotificationsList({
        destination: getUrlParamsMapV2()?.searchDep || getUrlParamsMapV2()?.destValue,
      });
      setNotificationsModal(true);
      setNotificationsAction(response?.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (isAgentLoggedIn()) {
      getNotificationsData();
    }
    saveCMPDetails();
  }, []);

  const [blockerNotificationsCount, unReadCount] = useMemo(() => {
    if (notificationsData) {
      let totalBlockerCount = 0;
      let totalUnreadCount = 0;
      for (const key in notificationsData) {
        notificationsData?.[key]?.forEach((item, index) => {
          if (!item?.isRead) {
            totalUnreadCount += 1;
            if (item?.isMandatory) {
              totalBlockerCount += 1;
            }
          }
        });
      }
      return [totalBlockerCount, totalUnreadCount];
    }
    return [0, 0];
  }, [notificationsData]);

  useEffect(() => {
    setBlockerCountAction({ blockerNotificationsCount, unReadCount });
  }, [blockerNotificationsCount, unReadCount]);

  const handleClick = () => {
    setAutoSuggest(!showAutosuggest);
  };

  const [modifySearchActive, setModifySearchActive] = useState(!isMobile());
  const handleMFS = () => {
    setModifySearchActive(true);
  };

  const handleCloseMFS = () => {
    setModifySearchActive(false);
  };

  const refreshPage = () => {
    reload();
  };

  const closeNotificationModal = () => {
    setNotificationsModal(false);
    setNotificationsPanel(true);
  };

  const openNotificationsPanel = () => {
    setNotificationsPanel(true);
  };

  // const nextBtnHandler = ({ currentIndex, type, target, nextIndex, nextTarget }) => {
  //   OmnitureUtils.trackClickEvent({ prop54: `${type}_cue_${currentIndex + 1}_${target}` });
  //   if (nextIndex >= 0) {
  //     OmnitureUtils.trackClickEvent({ prop54: `Seen_cue_${nextIndex + 1}_${nextTarget}` });
  //   }
  //   if (nextIndex === -1) {
  //     document.body.classList.remove('hideOverflow');
  //   }
  // };

  // const skipBtnHandler = ({ currentIndex, type, target }) => {
  //   OmnitureUtils.trackClickEvent({ prop54: `${type}_cue_${currentIndex + 1}_${target}` });
  //   document.body.classList.remove('hideOverflow');
  // };

  // const initCoachmarkHandler = ({ currentIndex, target }) => {
  //   OmnitureUtils.trackClickEvent({ prop54: 'cue_onboarding_seen' });
  //   if (currentIndex >= 0) {
  //     OmnitureUtils.trackClickEvent({ prop54: `Seen_cue_${currentIndex + 1}_${target}` });
  //   }
  // };

  // useEffect(() => {
  //   if (packagesLoaded) {
  //     window.CM = CoachmarkUtils;
  //     if (window?.localStorage) {
  //       const cuesObj = MMT_HLD.OnboardingCues_Listing;
  //       const cuesData = cuesObj?.[PAGE_NAME_LIST.LISTINGV3]
  //         ? cuesObj[PAGE_NAME_LIST.LISTINGV3]
  //         : null;
  //       if (!JSON.parse(window.localStorage.getItem(CLOSE_COACHMARK_CLICKED)) && cuesData) {
  //         document.body.classList.add('hideOverflow');
  //         coachmarkUtils({
  //           pageName: PAGE_NAME_LIST.LISTINGV3,
  //           callback: function() {
  //             CoachmarkUtils.showCoachMark(cuesData, {
  //               nextBtnTracker: nextBtnHandler,
  //               skipBtnTracker: skipBtnHandler,
  //               initEventHandler: initCoachmarkHandler,
  //             });
  //           },
  //           expiry: MMT_HLD.coachMarkExpire,
  //           cuesData,
  //         });
  //       } else {
  //         window?.localStorage?.setItem(CLOSE_COACHMARK_CLICKED, true);
  //       }
  //     }
  //   }
  // }, [packagesLoaded]);

  return (
    <div>
      {showNotifications && notificationsData && (
        <NotificationsOverlay
          notificationsData={notificationsData}
          setNotificationsPanel={setNotificationsPanel}
          blockerNotificationsCount={pendingNotificationsCount}
        />
      )}
      {blockerNotificationsCount > 0 && showNotificationsModal && (
        <NotificationsInfoModal
          blockerNotificationsCount={pendingNotificationsCount}
          closeModal={closeNotificationModal}
        />
      )}
      {modifySearchActive && isMobile() && <div className="transparentBg" />}
      {!isMobile() && (
        <Header
          selectedTabName="Holidays"
          showAgentLogin
          showLogout
          onLogout={refreshPage}
          onLogin={refreshPage}
          countryCode={getCookie('ccde')}
          pageName={PAGE_NAME.LISTING}
          classes="z1000"
          isIframe={getIframeValue()}
        />
      )}
      <div />
      <ModifySearch
        handleClick={handleClick}
        handleMFS={handleMFS}
        handleCloseMFS={handleCloseMFS}
        modifySearchActive={modifySearchActive}
        branch={branch}
        blockerNotificationsCount={unReadNotificationsCount}
        setNotificationsPanel={openNotificationsPanel}
      />
      <ListingBanner bannerForwaredRef={bannerHeightRef} isBannerShow={isBannerShow} />
      <ListingBody
        blockerNotificationsCount={pendingNotificationsCount}
        loadEventTriggered={loadEventSource !== null}
      />
      <Footer />
      {/* {packagesLoaded && <ContactManagementWrapper coachmarkShowFlag={coachMarkShown} />} */}
      {(!getMMT_HLD_OBJ()?.listingCtaPopupDelay ||
        (getMMT_HLD_OBJ()?.listingCtaPopupDelay && packagesLoaded)) &&
        !groupMetadataIsLoading && (
          <ContactManagementWrapper loadingPage={PAGENAME_LIST.LISTINGV3} />
        )}
      {!!listingFilters?.length && getMMT_HLD_OBJ().showRoadblock && <InterventionWrapper />}
    </div>
  );
};

const mapStateToProps = ({
  listingPackages,
  metadata,
  search,
  groupMetadata,
  notificationsReducer,
  sections,
}) => ({
  activeTab: groupMetadata?.groupDetailsList?.[0],
  initialDataLoaded: listingPackages?.initialDataLoaded,
  packagesLoaded: !!Object.keys(listingPackages?.packagesByGroupId || {})?.length,
  packages:
    listingPackages?.packagesByGroupId?.[groupMetadata?.groupDetailsList?.[0]?.id]?.packages,
  nextOffset:
    listingPackages?.packagesByGroupId?.[groupMetadata?.groupDetailsList?.[0]?.id]?.nextOffset,
  sectionsByOrderObj: sections?.sectionsByOrder || {},
  listingFilters: metadata?.listingFilters || [],
  branch: metadata?.branch,
  metadata,
  paxDetails: search?.default.roomGuest,
  groupMetadataIsLoading: groupMetadata?.isLoading,
  notificationsData: notificationsReducer?.notificationsData?.data,
  pendingNotificationsCount: notificationsReducer?.blockerNotificationsCount,
  unReadNotificationsCount: notificationsReducer?.unReadCount,
});

const mapDispatchToProps = {
  getListingFiltersAction,
  getListingMetaDataAction,
  getGroupMetaDataAction,
  getInitialPackagesAction,
  getListingSectionsAction,
  updateInitialValuesFromUrlAction,
  getSearchListAction,
  getMenuAction,
  getUserPackagesAction,
  setNotificationsAction,
  setBlockerCountAction,
  pageLoadingAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(HolidayListing);
